import { Box, Typography } from "@mui/material";
import React, { ElementType, ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  body?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
  /** Heading level of the title (2 to 6). Defaults to 2. */
  headingLevel?: 2 | 3 | 4 | 5 | 6;
}

export const EmptyState = ({
  title,
  body,
  action,
  icon,
  headingLevel = 2,
}: EmptyStateProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: 1,
      px: 3,
      py: 6,
    }}
  >
    {icon ? (
      <Box
        aria-hidden="true"
        sx={{ color: "text.secondary", display: "flex", mb: 1 }}
      >
        {icon}
      </Box>
    ) : null}
    <Typography
      component={`h${headingLevel}` as ElementType}
      sx={{ m: 0, fontSize: 16, fontWeight: 800, color: "text.primary" }}
    >
      {title}
    </Typography>
    {body ? (
      <Typography
        variant="body2"
        component="div"
        sx={{ color: "text.secondary", maxWidth: 420 }}
      >
        {body}
      </Typography>
    ) : null}
    {action ? <Box sx={{ mt: 2 }}>{action}</Box> : null}
  </Box>
);

export default EmptyState;
